import React from "react";
import {FormControl} from "react-bootstrap";
import {MultiSelectForm} from "./MultiSelectForm";
import arrow from './img/arrow-down.png'

const getByPath = (obj, path) => {
	if (!obj || !path) {
		return undefined;
	}

	return path.split(".").reduce((acc, key) => acc?.[key], obj);
};

export function SelectForm({ ele, formik, disabled }) {
	const options = ele.placeholder? [{value: '-1', label: ele.placeholder}, ...ele.options] : ele.options;
	const currentValue = getByPath(formik.values, ele.name);
	return (
		<>
			{ele.multi ? <MultiSelectForm ele={ele} formik={formik} />  : <FormControl
				custom
				as="select"
				style={{backgroundImage: `url(${arrow})`}}
				disabled={disabled || ele.disabled}
				value={currentValue !== undefined && currentValue !== "-1" ? currentValue : "-1"}
				onChange={(event) =>
					formik.setFieldValue(
						ele.name,
						event.target.value !== "-1" ? event.target.value : undefined
					)
				}
				{...(ele?.dataElement || {})}>
				{options.map((opt, index) => (
					<option key={opt.value} value={opt.value}>
						{opt.label}
					</option>
				))}
			</FormControl>}
		</>

	);
}
